var jade = require("/data/node/puzzle-author/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (undefined) {
buf.push("<div class=\"container-fluid bg-light editor\">" + (null == (jade_interp = require("/data/node/puzzle-author/views/game/edit/navs.jade").call(this, locals)) ? "" : jade_interp) + "<div class=\"game-edit-container\"><div style=\"min-width:980px;\" class=\"container h-100\"><textarea ng-model=\"_.editorGame\" style=\"resize:none;min-width:980px;\" class=\"h-100\"></textarea></div></div></div>");}.call(this,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}